import type { SVGProps } from "react";

export const Mail01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M6.06593 13.6423C7.35957 13.6748 8.64051 13.6748 9.93417 13.6423C12.0332 13.5895 13.0826 13.5632 13.8368 12.8063C14.5908 12.0493 14.6126 11.0275 14.6562 8.98373C14.6702 8.3266 14.6702 7.6734 14.6562 7.01627C14.6262 5.60841 14.6065 4.68547 14.3506 4L8.00004 7.33333L1.64945 4C1.39359 4.68547 1.37391 5.6084 1.34388 7.01627C1.32987 7.6734 1.32987 8.3266 1.34389 8.98373C1.38747 11.0275 1.40926 12.0493 2.16335 12.8063C2.91743 13.5632 3.96693 13.5895 6.06593 13.6423Z"
      fill="#1453F5"
    />
    <path
      d="M1.33337 4L5.94205 6.61131C7.64111 7.574 8.35897 7.574 10.058 6.61131L14.6667 4"
      stroke="#1453F5"
      strokeLinejoin="round"
    />
    <path
      d="M1.34389 8.98365C1.38747 11.0274 1.40926 12.0492 2.16335 12.8062C2.91743 13.5631 3.96693 13.5895 6.06593 13.6422C7.35957 13.6747 8.64051 13.6747 9.93417 13.6422C12.0332 13.5895 13.0826 13.5631 13.8368 12.8062C14.5908 12.0492 14.6126 11.0274 14.6562 8.98365C14.6702 8.32652 14.6702 7.67332 14.6562 7.01619C14.6126 4.97249 14.5908 3.95065 13.8368 3.19369C13.0826 2.43674 12.0332 2.41037 9.93417 2.35763C8.64051 2.32513 7.35957 2.32513 6.06592 2.35763C3.96693 2.41036 2.91743 2.43673 2.16334 3.19369C1.40925 3.95064 1.38747 4.97249 1.34388 7.01619C1.32987 7.67332 1.32987 8.32652 1.34389 8.98365Z"
      stroke="#1453F5"
      strokeLinejoin="round"
    />
  </svg>
);
